import styled, { css } from 'styled-components';

import { themeGet } from 'ravenjs/utils/theme';

const SearchInputCss = css`
    background-color: ${themeGet('palette.common.white')};
    border-radius: 4px;
    border: none;
    box-shadow: none;
    ${'' /* color: #7F8FA4; */};
    color: ${themeGet('palette.common.input')};
    display: block;
    font-size: 14px;
    line-height: 1.5;
    padding: 6px 6px 6px 0;
    width: ${({ showAdvancedSearch }) => (showAdvancedSearch ? '73%' : '100%')};
    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
    &::placeholder {
        ${'' /* color: #A6B3BE; */};
        color: ${themeGet('palette.common.placeholder')};
    }
    /**
     * Add styles for disabled and read-only
     */
    &[disabled],
    &[readonly] {
        background-color: ${themeGet('palette.common.inputDisabled')} !important;
        border-color: transparent;
        box-shadow: none;
        cursor: not-allowed;
        user-select: none;
    }
`;

const SearchInput = styled.input`
    ${SearchInputCss};
`;

export default SearchInput;
